import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Image,
  Table,
  Alert,
} from "react-bootstrap";

import { withRouter } from "react-router-dom";
class OrderSubmit extends Component {
  render() {
    const { data } = this.props;
    return (
      <Fragment>
        {/* {data.orderTopBannerImage && (
          <Image src={data.orderTopBannerImage} style={{ width: "100%" }} />
        )} */}
        <section className="order-form">
          <Container fluid>
            <Row>
              <Col md={12}>
                <p className="sucess">
                  Thanks you for your order. We will be in touch soon.
                </p>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Image
                  src={require("../../assets/img/thank-you.png")}
                  style={{ width: "30%" }}
                />
              </Col>
            </Row>
          </Container>
        </section>
      </Fragment>
    );
  }
}

export default withRouter(OrderSubmit);
